<script setup lang="ts">
import { useConfirm } from '@/shared/lib'

import ConfirmDialog from './ConfirmDialog.vue'

/**
 * The mount point `useConfirm` asks through. The app shell renders **exactly one** of
 * these: the state behind it is a module-level singleton, so a second one is as broken as
 * none — the question would be drawn twice and answered once.
 */
const { state, accept, cancel } = useConfirm()
</script>

<template>
  <ConfirmDialog
    v-if="state"
    :message="state.message"
    :confirm-label="state.options.confirmLabel"
    :tone="state.options.tone"
    @confirm="accept"
    @cancel="cancel"
  />
</template>
